var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('contractor-organization'),(false)?_c('checking-accounts'):_vm._e()],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }